function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.86 5h2.35c.18 0 .34.1.43.25l2.41 4.2c.09.15.09.34 0 .49l-4.64 8.3c-.19.34-.67.34-.87.01l-1.26-2.11a.497.497 0 010-.5l3.26-5.7c.09-.15.09-.34 0-.5l-2.13-3.7c-.17-.32.07-.74.45-.74z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M9.86 5h2.35c.18 0 .34.1.43.25l2.41 4.2c.09.15.09.34 0 .49l-4.64 8.3c-.19.34-.67.34-.87.01l-1.26-2.11a.497.497 0 010-.5l3.26-5.7c.09-.15.09-.34 0-.5l-2.13-3.7c-.17-.32.07-.74.45-.74z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.8 5h3.21c.18 0 .35.1.44.25l2.42 4.29c.09.15.09.34 0 .5l-1.12 1.92c-.19.33-.67.33-.86 0L1.8 5z"
})));